import { useState, useCallback } from 'react';
import {
  OrganizationSetupData,
  RemiSetupData,
  TwilioSetupData,
} from '../schemas/onboarding.schema';

interface OnboardingData {
  stage1?: OrganizationSetupData;
  stage3?: RemiSetupData;
  stage4?: TwilioSetupData;
  // Add more stages as needed
}

export const useOnboardingData = (initialStage: number = 0) => {
  const [onboardingData, setOnboardingData] = useState<OnboardingData>({});
  const [currentStage, setCurrentStage] = useState(initialStage);

  const saveStage1Data = useCallback((data: OrganizationSetupData) => {
    setOnboardingData((prev) => ({
      ...prev,
      stage1: data,
    }));
  }, []);

  const saveStage3Data = useCallback((data: RemiSetupData) => {
    setOnboardingData((prev) => ({
      ...prev,
      stage3: data,
    }));
  }, []);

  const saveStage4Data = useCallback((data: TwilioSetupData) => {
    setOnboardingData((prev) => ({
      ...prev,
      stage4: data,
    }));
  }, []);

  const goToNextStage = useCallback(() => {
    setCurrentStage((prev) => prev + 1);
  }, []);

  const goToPreviousStage = useCallback(() => {
    setCurrentStage((prev) => Math.max(1, prev - 1));
  }, []);

  return {
    onboardingData,
    currentStage,
    saveStage1Data,
    saveStage3Data,
    saveStage4Data,
    goToNextStage,
    goToPreviousStage,
  };
};
